export default class RevolverSettings {

    public static winCount: number = 0;
    
    public static lastWinTime: number = 0;
}